import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-alert"
}
const _hoisted_2 = { class: "page-alert-list container-md" }
const _hoisted_3 = { class: "d-block mb-half mb-md-0 fw-medium page-alert-label" }
const _hoisted_4 = { class: "d-block mb-1 mb-md-0 me-md-half page-alert-text" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.news && _ctx.news.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "page-alert-item",
              key: item.id
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(this.label), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
              _createElementVNode("a", {
                href: item.link,
                class: "d-block mx-auto me-md-0 page-alert-btn"
              }, _toDisplayString(this.linkLabel), 9, _hoisted_5)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}